module.exports = __webpack_public_path__ + "img/golang.99fb5516.svg";